import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {

  },


  mutations: {

  },

  actions: {

    async cancel({ commit }, { id }) {
      await actionClient.post(`member/personal/order-cancel/${id}`)
    }

  }


}
